import { useForm } from 'react-hook-form'
import clip from '../../statics/img/icons/clipRed.svg'
export default function SetConditions({ toggle, setConditions }: any) {

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();


  const onSubmit = (data: any) => {
    console.log(data)
    setConditions(data)
    toggle()
  };
  return (<>
    <div className="c-condition-modal">
      <div className="c-condition-modal-title">
        <img src={clip} alt="" />
        <h1>Conditions</h1>
      </div>
      <p>Por favor marca las condiciones para efectura el texto </p>
      <form onSubmit={handleSubmit(onSubmit)} id='conditionsForm'>
        <div className="left">
          <div className="item c-brands__inputs">
            <label className="c-input__checkbox">
              <input type="checkbox" id="condition1" {...register('condition1')} />
              <label htmlFor="condition1">No Repeat Winners</label>
              <span className="check" />
            </label>
          </div>
          {/* <div className="item c-brands__inputs">
            <label className="c-input__checkbox">
              <input type="checkbox" id="condition2"  {...register('condition2')} />
              <label htmlFor="condition2">No repear</label>
              <span className="check" />
            </label>
          </div>
          <div className="item c-brands__inputs">
            <label className="c-input__checkbox">
              <input type="checkbox" id="condition3" {...register('condition3')} />
              <label htmlFor="condition3">No repear</label>
              <span className="check" />
            </label>
          </div>
        </div>
        <div className="right">
          <div className="item c-brands__inputs">
            <label className="c-input__checkbox">
              <input type="checkbox" id="condition4" {...register('condition4')} />
              <label htmlFor="condition4">No repear</label>
              <span className="check" />
            </label>
          </div>
          <div className="item c-brands__inputs">
            <label className="c-input__checkbox">
              <input type="checkbox" id="condition5"{...register('condition5')} />
              <label htmlFor="condition5">Only California</label>
              <span className="check" />
            </label>
          </div>
          <div className="item c-brands__inputs">
            <label className="c-input__checkbox">
              <input type="checkbox" id="condition6" {...register('condition6')} />
              <label htmlFor="condition6">No repear</label>
              <span className="check" />
            </label>
          </div> */}
        </div>
      </form>
      <div className="buttons">
        <button onClick={toggle} className='buttonwinner'>Cancel</button>
        <button className='buttonwinner' type='submit' form='conditionsForm'>Save</button>
      </div>
    </div>

  </>)
}